<div style="display: flex;flex-direction: column">

  <ng-chain-branch-selector></ng-chain-branch-selector>

  @if (asvc.currentChainId) {

    @if (!asvc.IsBranchAssigned()) {
      <p-message severity="info" icon="fa fa-circle-info" size="large">
        {{ t('app', 'Schedule settings for this branch has not been specified. Please, click button to use Chain Settings as default.') }}
      </p-message>
    } @else {
      <p-tabs [value]="currentTab" [lazy]="true">
        <p-tablist>
          <p-tab value="positions" (click)="currentTab = 'positions'">{{ t('app', 'Positions') }}</p-tab>
          <p-tab value="approvers" (click)="currentTab = 'approvers'">{{ t('app', 'Predefined Approvers') }}</p-tab>
          <p-tab value="schedule" (click)="currentTab = 'schedule'">{{ t('app', 'Forms Schedule') }}</p-tab>
          <p-tab value="display-fields" (click)="currentTab = 'display-fields'">{{ t('app', 'Display Fields') }}</p-tab>
        </p-tablist>
        <p-tabpanels style="border: solid 1px var(--p-tabs-tablist-border-color);display: block; border-top: none;">
          <p-tabpanel value="positions">
            @if (currentTab === 'positions') {
              <ng-assignments-positions></ng-assignments-positions>
            }
          </p-tabpanel>
          <p-tabpanel value="approvers">
            @if (currentTab === 'approvers') {
              <ng-assignments-approvers></ng-assignments-approvers>
            }
          </p-tabpanel>
          <p-tabpanel value="schedule">
            @if (currentTab === 'schedule') {
              <ng-assignments-schedule></ng-assignments-schedule>
            }
          </p-tabpanel>
          <p-tabpanel value="display-fields">
            @if (currentTab === 'display-fields') {
              <ng-assignments-display-fields></ng-assignments-display-fields>
            }
          </p-tabpanel>
        </p-tabpanels>
      </p-tabs>
    }

    <div style="height: 1rem"></div>

    <div>
      <p-button
        icon="fa fa-trash"
        severity="danger"
        label="{{ t('app', 'Unassign Chain') }}"
        (click)="asvc.UnAssignChain()"/>
    </div>
  }

</div>
